(function() {
    var rss = require('./rss');
    rss.add_feed("blog",  window.__rss.blog);
    rss.add_feed("forum", window.__rss.forum);
  })()(function() {
    var rss = require('./rss');
    rss.add_feed("blog",  window.__rss.blog);
    rss.add_feed("forum", window.__rss.forum);
  })()